/* eslint-disable jsx-a11y/anchor-is-valid */
import useIsMobile from 'utils/hooks/useIsMobile'
import {Tooltip, useMediaQuery} from '@mui/material'
import {FC} from 'react'
import {toAbsoluteUrl} from '../../helpers'

const Footer: FC = () => {
  const isMobile = useIsMobile()
  const isWide = useMediaQuery('(min-width: 1300px)')

  return (
    <div className='footer flex py-6 lg:flex-col px-6'>
      <div className='flex w-full flex-col items-center justify-between px-3 md:flex-row'>
        <div className='order-[2] my-4 text-gray-800 md:order-[1]'>
          <span className='mr-2 font-bold text-gray-400'>{2023} &copy;</span>
          <a
            href='https://www.young-it.co.kr'
            target={'_blank'}
            className='font-bold text-gray-500 hover:text-[#009EF7]'
            rel='noreferrer'
          >
            YOUNG-IT | Meterarium
          </a>
          <span className={'ml-4 font-bold text-white'} hidden={isMobile}>
            Developed By :나현균, 정호연
          </span>
        </div>
        <ul className='order-[1] mb-4 flex list-none items-center gap-6 font-semibold'>
          <li>
            <a
              href='https://young-it.co.kr'
              target={'_blank'}
              className='flex text-lg'
              rel='noreferrer'
            >
              <Tooltip
                title={<span className={'fs-6'}>영아이티 홈페이지</span>}
                className={''}
                arrow={true}
              >
                <img
                  src={toAbsoluteUrl('/media/logos/youngit_logo_mini.png')}
                  alt={'youngit'}
                  className={!isMobile ? 'h-[30px]' : 'h-[25px]'}
                />
              </Tooltip>
            </a>
          </li>

          {/* <li className='self-center'>
            <a
              href='http://pf.kakao.com/_rxbZaxj'
              className='flex pr-12 text-lg'
              target={'_blank'}
              rel='noreferrer'
            >
              <Tooltip
                title={<span className={'fs-6'}>영아이티 카카오채널 연결</span>}
                className={''}
                arrow={true}
              >
                <img
                  src={toAbsoluteUrl('/media/logos/youngit-kakao.png')}
                  alt={'kakaoch'}
                  className={isWide ? 'h-[35px]' : 'h-[25px]'}
                />
              </Tooltip>
            </a>
          </li> */}
        </ul>
      </div>
    </div>
  )
}

export {Footer}
